export const BLACK_FRIDAY_START = new Date('2024-11-25 00:00:00').getTime();
export const BLACK_FRIDAY_END = new Date('2024-12-02 00:00:00').getTime();
export const IS_BLACK_FRIDAY = new Date().getTime() >= BLACK_FRIDAY_START && new Date().getTime() <= BLACK_FRIDAY_END;